import { Database, Clock, Shield, Bell } from "lucide-react";
import AnimatedNumber from "@/components/AnimatedNumber";

const VALUE_ITEMS = [
  {
    icon: Database,
    label: "OSINT + Markets + Nuclear + AI",
  },
  {
    icon: Clock,
    label: (
      <span className="flex items-center gap-1">
        <AnimatedNumber value={47} suffix=" min" duration={1500} />
        <span className="text-muted-foreground font-normal">lead time vs. media</span>
      </span>
    ),
  },
  {
    icon: Bell,
    label: "Real-time push alerts",
  },
  {
    icon: Shield,
    label: "56 tools · One subscription",
  },
];

const ValueProposition = () => {
  return (
    <section className="border-b border-border bg-muted/30">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-center gap-3 md:gap-6 flex-wrap">
          {VALUE_ITEMS.map((item, i) => {
            const Icon = item.icon;
            return (
              <div key={i} className="flex items-center gap-2">
                {i > 0 && (
                  <div className="hidden md:block h-4 w-px bg-border -ml-1 md:-ml-3 mr-1 md:mr-0" />
                )}
                <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary/10 text-primary">
                  <Icon className="h-3 w-3" />
                </div>
                <span className="text-[11px] md:text-xs font-semibold text-foreground whitespace-nowrap">
                  {item.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
